<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between start">
  <h2>{{ 'header.personalizar.titulo' | translate }}</h2>
</div>

<!--
<h2>{{"header.personalizar.titulo" | translate}}</h2>
-->

<mat-dialog-content fxLayout="column" style="max-height: 100vh">
  <p>{{ 'header.personalizar.subtitulo' | translate }}</p>
  <div class="container imc--personalitzar">
    <form (ngSubmit)="onGuardar(refFormulario)" #refFormulario="ngForm">
      <div fxLayout="row" class="imc--elms">
        <div fxFlex="25" fxLayoutAlig="space-evenly center">
          <mat-form-field>
            <mat-label>{{ 'header.personalizar.temaColores.etiqueta' | translate }}</mat-label>
            <mat-select name="selectorTemaVisual" [(ngModel)]="configuracion.temaVisual" placeholder="">
              <mat-option *ngFor="let tema of opcionesTemasVisuales" [value]="tema.id">
                {{ tema.i18n | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div fxFlex="25">
          <mat-form-field>
            <mat-label>{{ 'header.personalizar.tamanyoElementos.etiqueta' | translate }}</mat-label>
            <mat-select name="selectorTamanyoElementos" [(ngModel)]="configuracion.tamanyoElementos" placeholder="">
              <mat-option *ngFor="let tamanyo of opcionesTamanyosElementos" [value]="tamanyo.id">
                {{ tamanyo.i18n | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div fxFlex="25" fxLayoutGap="20">
          <mat-form-field>
            <mat-label>{{ 'header.personalizar.ayudaPantalla.etiqueta' | translate }}</mat-label>
            <mat-select name="selectorAyudaPantalla" [(ngModel)]="configuracion.ayudaEnPantalla" placeholder="">
              <mat-option [value]="true">{{ 'SI' | translate }}</mat-option>
              <mat-option [value]="false">{{ 'NO' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div fxFlex="25">
          <mat-form-field>
            <mat-label>{{ 'header.personalizar.destacarSeleccion.etiqueta' | translate }}</mat-label>
            <mat-select name="selectorDestacarSeleccion" [(ngModel)]="configuracion.destacarSeleccion" placeholder="">
              <mat-option [value]="true">{{ 'SI' | translate }}</mat-option>
              <mat-option [value]="false">{{ 'NO' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="80px" class="imc--botonera tel-m-t--3">
        <button class="tel-button-icon normal_size" type="submit">
          <mat-icon>save</mat-icon>
          Guardar
        </button>
        <button class="tel-button-icon normal_size light_option" (click)="abrirAyuda()" type="button">
          <mat-icon>help_outline</mat-icon>
          Ayuda
        </button>
      </div>
    </form>
  </div>
</mat-dialog-content>
